import { Optional, Pipe, PipeTransform } from '@angular/core';
import { TemperatureUnit } from '../../auth/models/mmu-user-preferences';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { MmuFormatNumberPipe } from '../format-number/format-number.pipe';
import { MmuTemperaturePipe, TemperatureConversion } from './temperature.pipe';


@Pipe({
  name: 'formatTemperature',
  pure: true
})
/**
 * This pipe is used to format the temperature according to the user's preferred format.
 */
export class MmuFormatTemperaturePipe implements PipeTransform {
  private temperaturePipe: MmuTemperaturePipe;
  private formatNumberPipe: MmuFormatNumberPipe;
  private readonly temperatureUnit: TemperatureUnit;

  constructor(@Optional() private mmuUserService: MmuUserService) {
    if (this.mmuUserService == null) {
      this.temperatureUnit = TemperatureUnit.CELSIUS;
    } else {
      this.temperatureUnit = this.mmuUserService.user?.prefs?.temperatureUnit ?? TemperatureUnit.CELSIUS;
    }
    this.temperaturePipe = new MmuTemperaturePipe();
    this.formatNumberPipe = new MmuFormatNumberPipe(this.mmuUserService);
  }

  transform(celsius: number, digitsInfo?: string): string {
    const value: number = this.convertValue(celsius);
    const valueString: string = this.formatNumberPipe.transform(value, digitsInfo);
    const unitString: string = this.unitString();
    return valueString + ' ' + unitString;
  }

  private convertValue(celsius: number): number {
    if (this.temperatureUnit == TemperatureUnit.FAHRENHEIT) {
      return this.temperaturePipe.transform(celsius, TemperatureConversion.C_F);
    }
    return celsius;
  }

  private unitString(): string {
    if (this.temperatureUnit == TemperatureUnit.FAHRENHEIT) {
      return '°F';
    }
    return '°C';
  }
}
